<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6V13M12 17.5V18" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>